/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import AppLink from '../../shared/components/app-link/AppLink';
import { NAVIGATION_ROUTES } from '../../shared/constants/Constants';

function ManageFlightCancellation({ flightRecord }) {
  const getFlightTicket = (txid) => {
    let route = NAVIGATION_ROUTES.FLIGHT.FLIGHT_REFUND_RECEIPT;
    route = route.replace(':transactionId', txid);
    return route;
  };

  return (
    <div className="overflow-auto fs-14 table-responsive">
      {flightRecord && flightRecord.length > 0 && (
        <table className="table fs-12 table-bordered">
          <thead>
            <tr>
              <th>Tx ID</th>
              <th>TX Date</th>
              <th>Reference Tx ID</th>
              <th>Remarks</th>
              <th>Company</th>
              <th>Status</th>
              <th>Refund Amount</th>
              <th>Refund Receipt</th>
            </tr>
          </thead>
          <tbody>
            {flightRecord.map((x, index) => (
              <tr key={index}>
                <td>{x.Txid}</td>
                <td>{x.TxDate}</td>
                <td>{x.ReferenceTxid}</td>
                <td>{x.Remarks}</td>
                <td>{x.AgentCompany}</td>
                <td>{x.Status}</td>
                <td>{x.RefundAmount}</td>
                <td>
                  <AppLink
                    linkText="Refund Receipt"
                    isLink
                    target="_blank"
                    href={getFlightTicket(x.Txid)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

ManageFlightCancellation.propTypes = {
  flightRecord: PropTypes.object.isRequired,
};

export default ManageFlightCancellation;
